import { render, staticRenderFns } from "./Bookplace.vue?vue&type=template&id=db21d834&"
import script from "./Bookplace.vue?vue&type=script&lang=js&"
export * from "./Bookplace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports